import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TransportStatus, TransportStatuses, TransportStatusesColors } from '@icc/b2b/shared';

@Component({
    selector: 'icc-transport-status',
    templateUrl: './transport-status.component.html',
    styles: [':host { display: inline-block; }'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportStatusComponent {
    private _status: TransportStatus;

    @Input()
    get status(): TransportStatus {
        return this._status;
    }
    set status(value: TransportStatus) {
        this._status = value;
        this.colorRgbHex = TransportStatusesColors[value];
        this.name = TransportStatuses[value];
    }

    colorRgbHex = '';
    name = '';
}
